(function () {
  const mq = window.matchMedia('(min-width: 750px)');
  const detailsList = document.querySelectorAll('.footer-block__accordion > .footer-block__details');

  function syncDetails(e) {
    const isDesktop = e.matches;
    detailsList.forEach((d) => {
      if (isDesktop) {
        d.setAttribute('open', '');
      } else {
        d.removeAttribute('open');
      }
    });
  }

  syncDetails(mq);
  mq.addEventListener('change', syncDetails);
})();